import React from 'react';

const TermsConditions = () => (
  <div>
    <div className="page-header">
      <div className="container"><h1>Terms &amp; Conditions</h1><p>The rules for using 5Star</p></div>
    </div>
    <div className="policy-content">
      <h2>Use of the Site</h2>
      <p>By accessing and placing an order with 5Star, you confirm that you are at least 18 years of age and that the information you provide is accurate and complete.</p>

      <h2>Products &amp; Pricing</h2>
      <p>We make every effort to display product colours, materials and specifications accurately, but slight variations may occur. Prices are listed in Indian Rupees and are subject to change without notice. We reserve the right to correct pricing errors and to limit order quantities.</p>

      <h2>Orders</h2>
      <p>All orders are subject to acceptance and availability. We may refuse or cancel an order for reasons including stock unavailability, suspected fraud, or errors in pricing or product information.</p>

      <h2>Warranty</h2>
      <p>Warranty periods stated on product pages cover manufacturing defects under normal use. They do not cover damage from misuse, airline handling beyond fair wear, unauthorized repairs, or normal cosmetic wear.</p>

      <h2>Limitation of Liability</h2>
      <p>5Star is not liable for any indirect or consequential loss arising from the use of our products or website, to the fullest extent permitted by law.</p>

      <h2>Contact</h2>
      <p>Questions about these terms can be sent to <a href="mailto:support@fivestar.example.com">support@fivestar.example.com</a>.</p>
    </div>
  </div>
);

export default TermsConditions;
